module.exports = __webpack_public_path__ + "static/media/not-motivated.aa485516.svg";